export default __webpack_public_path__ + "static/media/ad.8297763c.svg";